import { render, staticRenderFns } from "./ServicePlaceBranchForm.vue?vue&type=template&id=4aea0635&scoped=true&"
import script from "./ServicePlaceBranchForm.vue?vue&type=script&lang=js&"
export * from "./ServicePlaceBranchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aea0635",
  null
  
)

export default component.exports